type State = Record<string, never>;

export const actionMap = {};

export const initialState: State = {};
